<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'app'
}
</script>

<style>
@import '~nprogress/nprogress.css';

#nprogress .spinner {
    display: none !important;
}
* {
    padding: 0;
    margin: 0;
}

body {
    font-family: 'PingFang SC', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    min-width: 1366px;
}

/*表单说明文字 1*/
.help-block {
    font-size: 0.8em;
    color: cadetblue;
}

/* 上传框样式 */

.imgupd-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.imgupd-uploader .el-upload:hover {
    border-color: #409eff;
}

.imgupd-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
}

/*TINYMCE */
.mce-tinymce {
    width: calc(100% - 2px) !important;
}

/* 修复字数显示bug */
.el-input .el-input__count .el-input__count-inner {
    background: transparent !important;
}

/* 滚动条 start*/

::-webkit-scrollbar {
    width: 7px;
    height: 4px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #fff;
}

::-webkit-scrollbar-thumb {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 0.7);
}

::-webkit-scrollbar-thumb:hover {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 1);
}

.amap {
    width: 100%;
    height: 500px;
}
</style>
